import type { Brand } from '../../model';

/** Query-key prefix of agency-workspace demand queries; empty outside an agency workspace. */
export function agencyDemandQueryPrefix(networkId: string, scopeAgencyId: string | undefined) {
  return scopeAgencyId ? ['agency-demand', networkId, scopeAgencyId] : [];
}

/** Keeps the cached agency when the update response omits it. */
export function preserveBrandAgency(updated: Brand, previous: Brand): Brand {
  return { ...updated, agency: updated.agency === undefined ? previous.agency : updated.agency };
}

/** Industry options, falling back to the edited brand's industry while the list is unavailable. */
export function resolveBrandIndustries(
  industries: string[] | undefined,
  brand: Brand | null,
): string[] {
  return industries ?? (brand?.industry ? [brand.industry] : []);
}
